import React from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import theme from './themes/theme';
import CompanyWebsite from './components/CompanyWebsite';
import PrivacyPage from './components/PrivacyPage';
import TermsPage from './components/TermsPage';
import NotFoundPage from './components/NotFoundPage';
import ScrollToTop from './components/ScrollToTop';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <ScrollToTop />
        {/*
          Sections animate in from the side, so a not-yet-revealed element sits at
          an x-offset that would otherwise widen the page. `clip` contains that
          without creating a scroll container (which `hidden` would), keeping
          position: sticky and smooth scrolling intact.
        */}
        <Box component="main" id="main" sx={{ overflowX: 'clip' }}>
          <Routes>
            <Route path="/" element={<CompanyWebsite />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Box>
        <CookieConsent />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
